module.exports = __webpack_public_path__ + "img/collection-icon.5b6851f2.png";